/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './regimen-investigation.reducer';

export const RegimenInvestigationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const regimenInvestigationEntity = useAppSelector(state => state.regimenInvestigation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="regimenInvestigationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.regimenInvestigation.detail.title">RegimenInvestigation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.regimenInvestigation.id">Id</Translate>
            </span>
          </dt>
          <dd>{regimenInvestigationEntity.id}</dd>
          <dt>
            <span id="cycleNumber">
              <Translate contentKey="tinyMedicRestApp.regimenInvestigation.cycleNumber">Cycle Number</Translate>
            </span>
          </dt>
          <dd>{regimenInvestigationEntity.cycleNumber}</dd>
          <dt>
            <span id="associationType">
              <Translate contentKey="tinyMedicRestApp.regimenInvestigation.associationType">Association Type</Translate>
            </span>
          </dt>
          <dd>{regimenInvestigationEntity.associationType}</dd>
          <dt>
            <span id="noteOrInstructions">
              <Translate contentKey="tinyMedicRestApp.regimenInvestigation.noteOrInstructions">Note Or Instructions</Translate>
            </span>
          </dt>
          <dd>{regimenInvestigationEntity.noteOrInstructions}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.regimenInvestigation.active">Active</Translate>
            </span>
          </dt>
          <dd>{regimenInvestigationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.regimenInvestigation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{regimenInvestigationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.regimenInvestigation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{regimenInvestigationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.regimenInvestigation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{regimenInvestigationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.regimenInvestigation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{regimenInvestigationEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenInvestigation.regimen">Regimen</Translate>
          </dt>
          <dd>{regimenInvestigationEntity.regimen ? regimenInvestigationEntity.regimen.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenInvestigation.cycle">Cycle</Translate>
          </dt>
          <dd>{regimenInvestigationEntity.cycle ? regimenInvestigationEntity.cycle.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenInvestigation.imageTest">Image Test</Translate>
          </dt>
          <dd>{regimenInvestigationEntity.imageTest ? regimenInvestigationEntity.imageTest.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenInvestigation.panel">Panel</Translate>
          </dt>
          <dd>{regimenInvestigationEntity.panel ? regimenInvestigationEntity.panel.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenInvestigation.labTestItem">Lab Test Item</Translate>
          </dt>
          <dd>{regimenInvestigationEntity.labTestItem ? regimenInvestigationEntity.labTestItem.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/regimen-investigation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/regimen-investigation/${regimenInvestigationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RegimenInvestigationDetail;
